export const INPUT_SUBCATEGORY_ID = 'id_subcategory';
export const INPUT_BILLING_ANSWER_ID = 'id_billing_answer';
export const INPUT_NAME_ID = 'id_name';
export const INPUT_DEAL_NAME_TEMPLATE_ID = 'id_deal_name_template';
export const INPUT_DESCRIPTION_ID = 'id_description';
